import { useEffect, useState } from 'react';

export default function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 2;
      });
    }, 30);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 bg-[#0a0a0a] z-50 flex items-center justify-center">
      {/* Grid Pattern Overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'linear-gradient(#00d9ff 1px, transparent 1px), linear-gradient(90deg, #00d9ff 1px, transparent 1px)',
        backgroundSize: '50px 50px'
      }} />

      <div className="relative z-10 flex flex-col items-center">
        {/* Logo Container */}
        <div className="relative mb-32">
          {/* Scanning Line Effect */}
          <div className="absolute inset-0 overflow-hidden">
            <div className="absolute w-full h-1 bg-gradient-to-r from-transparent via-[#00d9ff] to-transparent animate-scan" 
                 style={{ 
                   animation: 'scan 2s ease-in-out',
                   top: '0',
                   transform: 'translateY(0)'
                 }} />
          </div>

          {/* Rotating Hexagon */}
          <div className="absolute inset-0 flex items-center justify-center animate-spin-slow">
            <div className="w-64 h-64 border border-[#00d9ff]/30 rotate-45" style={{ clipPath: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)' }} />
          </div>

          {/* Logo */}
          <div className="relative animate-fade-in" style={{ animationDelay: '1.5s' }}>
            <img 
              src="https://static.readdy.ai/image/d01eec00e4772b31ebec3f16d57f9686/a135775721950a9d58bee29176af8952.jpeg"
              alt="TETRA Logo"
              className="w-48 h-48 object-contain filter drop-shadow-[0_0_30px_rgba(0,217,255,0.5)]"
            />
          </div>

          {/* Electric Arc Effect */}
          <div className="absolute inset-0 animate-pulse" style={{ animationDuration: '2s' }}>
            <div className="absolute top-0 left-1/2 w-1 h-8 bg-gradient-to-b from-[#00d9ff] to-transparent opacity-60" />
            <div className="absolute bottom-0 left-1/2 w-1 h-8 bg-gradient-to-t from-[#00d9ff] to-transparent opacity-60" />
            <div className="absolute left-0 top-1/2 h-1 w-8 bg-gradient-to-r from-[#00d9ff] to-transparent opacity-60" />
            <div className="absolute right-0 top-1/2 h-1 w-8 bg-gradient-to-l from-[#00d9ff] to-transparent opacity-60" />
          </div>
        </div>

        {/* Loading Bar */}
        <div className="relative w-[300px] mb-6">
          <div className="h-0.5 bg-white/10 rounded-full overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-[#00d9ff] to-[#00d9ff]/50 transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="absolute -top-8 right-0 text-[#00d9ff] font-mono text-sm tracking-wider">
            {progress}%
          </div>
        </div>

        {/* Slogan */}
        <div className="animate-fade-in" style={{ animationDelay: '2s' }}>
          <h2 className="text-white/70 text-sm tracking-[0.3em] uppercase font-light">
            Engineering the Future
          </h2>
        </div>
      </div>

      <style>{`
        @keyframes scan {
          0% { transform: translateY(0); opacity: 0; }
          50% { opacity: 1; }
          100% { transform: translateY(200px); opacity: 0; }
        }
        @keyframes fade-in {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        .animate-fade-in {
          animation: fade-in 1s ease-out forwards;
          opacity: 0;
        }
        .animate-spin-slow {
          animation: spin 20s linear infinite;
        }
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
